import {ROUTES_PATHS} from "./routes";

export const menuItemsBreadcrumb = [
	{
		"id": 1,
		"label": "Bâtiment",
		"page": ROUTES_PATHS.BATIMENT
	},
	{
		"id": 2,
		"label": "Pièces",
		"page": ROUTES_PATHS.PIECES
	},
	{
		"id": 3,
		"label": "Estimation",
		"page": ROUTES_PATHS.ESTIMATION_RAPIDE
	}
]
